import 'bootstrap';
import './resources/scss/app.scss';
import './services/i18n';
import App from './routes/App.svelte';
const APP_NAME = process.env.APP_NAME;
const app = new App({
    target: document.body,
    props: {
        name: APP_NAME !== null && APP_NAME !== void 0 ? APP_NAME : 'Ondjyla'
    }
});
export default app;
